import { helpers, required } from '@vuelidate/validators';

/**
 * Client rules for "Create Curriculum", mirroring createCurriculumInput: a
 * programme, a level, a semester (0 means any semester) and at least one
 * course with its status. Each problem is shown under its own field.
 */
export const curriculumFormRules = {
  programme_id: {
    required: helpers.withMessage('Choose a programme.', required),
  },
  course_registration_level: {
    required: helpers.withMessage('Choose a level.', required),
  },
  semester: {
    chosen: helpers.withMessage(
      'Choose a semester.',
      (value: number | string | null | undefined) => value !== '' && value !== null && value !== undefined
        && Number.isFinite(Number(value)) && Number(value) >= 0,
    ),
  },
  course: {
    atLeastOne: helpers.withMessage(
      'Add at least one course and choose whether it is compulsory or elective.',
      (courses: Array<{ course_id: string; status: string }> | undefined) => (courses?.length ?? 0) > 0,
    ),
  },
};
